module.exports = __webpack_public_path__ + "static/media/savepercentagev2.6f16342f.png";